import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposServidores } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposServidores() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_SERVIDORES, paginaPermissao: FUNCIONALIDADES.TIPOS_SERVIDORES, rota: ROUTES.TIPOS_SERVIDORES, fetchData: function (str, _, pag) { return getTiposServidores(str, pag); }, columns: COLUNAS }));
}
